import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'
import { toDateFormatComma } from '~/shared/utils/date'

export default class DigitalLectureCourseCard extends BaseModel {
  static override constructorName = 'DigitalLectureCourseCard'

  id: number = 0
  name: string = ''
  slug: string = ''
  preview: string = ''
  'short_description': string = ''
  'date_publication': string = ''
  'likes_count': number = 0
  'views_count': number = 0

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }

    this.preview = toCroppedImage(this.preview)

    if (this.date_publication) {
      this.date_publication = toDateFormatComma(this.date_publication)
    }
  }
}

registerModel(DigitalLectureCourseCard)
